import { Link } from "react-router-dom";
import { Dumbbell, Flame, Activity, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";

const programs = [
  { icon: Flame, name: "Foundations", weeks: "8 weeks", desc: "Build a strength base with progressive overload and mobility work.", points: ["3 sessions / week", "Form & technique focus", "Nutrition primer"] },
  { icon: Dumbbell, name: "Recomposition", weeks: "12 weeks", desc: "Body composition-focused training to complement your performance goals.", points: ["4 sessions / week", "Strength + conditioning", "Weekly check-ins"] },
  { icon: Activity, name: "Elite Performance", weeks: "16 weeks", desc: "Advanced periodized programming for serious performance outcomes.", points: ["5 sessions / week", "Periodized blocks", "1:1 coaching calls"] },
];

export default function Training() {
  return (
    <>
      <Seo title="Physical Training Coaching Programs | Just Peptides Supply" description="Structured strength and conditioning coaching programs to complement your performance journey." path="/training" />

      <section className="relative overflow-hidden bg-brand-ink text-white">
        <img src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/85 to-transparent" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-24">
          <p className="font-mono-label text-xs uppercase tracking-[0.25em] text-brand-teal">Coaching</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight max-w-2xl">Physical training, built around you</h1>
          <p className="mt-5 max-w-xl text-white/70 text-lg">Programmed strength and conditioning coaching designed to complement your total performance journey.</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-20">
        <div className="grid gap-6 md:grid-cols-3">
          {programs.map((p, i) => (
            <div key={p.name} className="fade-up rounded-2xl border border-brand-navy/10 bg-white p-7 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(20,47,76,0.4)] transition-[transform,box-shadow] duration-300" style={{ animationDelay: `${i * 70}ms` }}>
              <div className="flex items-center justify-between">
                <div className="rounded-xl bg-brand-mist p-3"><p.icon className="h-6 w-6 text-brand-blue" /></div>
                <span className="font-mono-label text-[11px] uppercase tracking-[0.15em] text-brand-navy/50">{p.weeks}</span>
              </div>
              <h3 className="mt-5 font-display text-2xl text-brand-navy">{p.name}</h3>
              <p className="mt-2 text-sm text-brand-navy/55">{p.desc}</p>
              <ul className="mt-5 space-y-2">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-center gap-2 text-sm text-brand-navy/70">
                    <span className="h-1.5 w-1.5 rounded-full bg-brand-teal" /> {pt}
                  </li>
                ))}
              </ul>
              <Link to="/telehealth">
                <Button data-testid={`enroll-${p.name.toLowerCase().replace(/\s+/g, "-")}`} className="mt-6 w-full rounded-full bg-brand-navy hover:bg-brand-teal text-white">
                  Enroll <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
